import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

// Set a `basename` to be used by the Router/
const basename = process.env.NODE_ENV === 'production' ? '/login' : '/';

const PianoLoginFormComponent = lazy(() => import('../components/PianoLoginForm/PianoLoginForm'));
const PianoLoginForm = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <PianoLoginFormComponent />
  </Suspense>;

const PianoForgotPasswordFormComponent = lazy(() => import('../components/PianoForgotPasswordForm/PianoForgotPasswordForm'));
const PianoForgotPasswordForm = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <PianoForgotPasswordFormComponent />
  </Suspense>;

const PianoResetPasswordFormComponent = lazy(() => import('../components/PianoResetPasswordForm/PianoResetPasswordForm'));
const PianoResetPasswordForm = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <PianoResetPasswordFormComponent />
  </Suspense>;

const LogoutComponent = lazy(() => import('./Logout/Logout'));
const Logout = () =>
  <Suspense fallback={<div>Loading...</div>}>
    <LogoutComponent />
  </Suspense>;

const AllRoutes = () => (
  <Router
    basename={basename}
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Routes>
      <Route exact path="/:archive?" element={<PianoLoginForm />}/>
      <Route exact path="/logout" element={<Logout />} />
      <Route exact path="/reset-password?" element={<PianoResetPasswordForm />} />
      <Route exact path="/forgot-password" element={<PianoForgotPasswordForm />} />
    </Routes>
  </Router>
);

const Main = () => (
  <AllRoutes />
);

export default Main;
